<template>
  <!-- <div class="landing md-scrollbar smooth-scrollbar" ref="scrollArea"> -->
  <div class="landing">
    <div class="bg xsmall-hide small-hide">
      <div class="container md-elevation-4">
        <div class="sub-tag-cover md-elevation-1"
             style="width:200px; height:300px;">
          <!-- <span class="app-carousel-intro"><span class="green">nano</span> + <span class="blue">iungere</span>  = <span class="green">nan</span><span class="blue">iungo</span>®</span> -->
          <h1>
            DIE <br> EXPERTEN <br> BOUTIQUE
          </h1>
          <p>naniungo verbindet Unternehmen mit Experten!</p>
          <md-menu md-direction="bottom-end">
            <md-button style="margin-left:1px;"
                       class="md-raised"
                       md-menu-trigger>
              <span style="text-transform:uppercase; font-size:10px; color:$accent">
                Expertenprofile </span>
              <md-icon class="green">arrow_forward</md-icon>
            </md-button>
            <md-menu-content>
              <md-menu-item>
                <router-link style="width:100%;"
                             v-bind:to="'/projects'"
                             exact>
                  projects
                </router-link>
              </md-menu-item>
              <md-menu-item>
                <router-link style="width:100%;"
                             v-bind:to="'/executives'"
                             exact>
                  excecutives
                </router-link>
              </md-menu-item>
              <md-menu-item>
                <router-link style="width:100%;"
                             v-bind:to="'/representatives'"
                             exact>
                  representatives
                </router-link>
              </md-menu-item>
            </md-menu-content>
          </md-menu>
        </div>
        <div class="sub-tag-cover cover-slogan sub cover xsmall-hide">
          <span class="yellow">Wir vermitteln Spezialisten mit gefragten Skills für Ihre Projekte.</span>
        </div>
      </div>
    </div>
    <div class="medium-hide large-hide xlarge-hide">
      <img src="../assets/naniungo-slide-9.jpg">

    </div>
    <div class="md-layout">
      <div class="md-layout-item m-25 md-xsmall-size-100 header-col">
        <h1>
          naniungo® verbindet 
        </h1>
        <div class="sub">
         Unternehmen mit Business Experten. Finance, Sales & Marketing, HR, Procurement und IT.
        </div>
      </div>
      <div class="md-layout-item m-25 md-xsmall-size-100 text-col-50">
        <p>
          Wir vereinen unser Know-how und nutzen unser Netzwerk an hochkarätigen Spezialisten, um Ihr Unternehmen noch erfolgreicher zu machen. Dabei setzen wir auf die gebündelte Mischung aus Kompetenz und Erfahrung, Persönlichkeit und Innovation, sowie Individualität und Umsetzungsstärke.
        </p>
        <p>
          Unsere Unternehmensberatung umfasst weit mehr als die reine Personalberatung und das Interim Business: Wir verstehen uns als moderner Mediator, der zwischen Unternehmen, den Angestellten und den Vertriebs- und Marketingaktivitäten agiert. Was wir genau tun?
        </p>
        <router-link style="width:100%;"
                     v-bind:to="'about'">
          <md-button style="margin-left:1px;"
                     class="md-raised"
                     md-menu-trigger>
            <span style="text-transform:uppercase; font-size:10px; color:$accent">
              weiterlesen</span>
            <md-icon class="green">arrow_forward</md-icon>
          </md-button>
        </router-link>
      </div>
    </div>
    <div class="md-layout"
         style="border-top: 2px solid white;">
      <div class="md-layout-item">
        <div class="container">
          <!-- <div class="sub-tag-content xsmall-hide small-hide">
            <img style="width:200px;" src="../assets/naniungo_dach.png">
        </div> -->
          <div class="sub-tag-content slogan xsmall-hide small-hide">
            <h1>Über Uns</h1>
            <p>Wir vereinen Kompetenz und fachliches Know-how mit dem persönlichen Streben nach optimalen Lösungen für Ihre Projekte und Personalthemen.</p>
            <router-link style="width:100%;"
                         v-bind:to="'about'">
              <p>mehr<md-icon style="color:white;">arrow_forward</md-icon>
              </p>
            </router-link>
          </div>
          <img src="../assets/naniungo-slide-13.jpg">
        </div>
      </div>
    </div>

    <div class="md-layout mt-100">
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-tabs class="md-transparent landing-tabs"
                 md-alignment="centered">
          <md-tab id="tab-bewerber"
                  md-label="Für Unternehmen">
            <div class="md-layout section-grey"
                 id="services">
              <div class="md-layout-item md-xsmall-size-100">
                <div class="tabs-margin">
                  <img style="height:96px;"
                       src="../assets/media/hr-icon-2.svg">
                  <h1>
                    projects
                  </h1>
                  <p>
                    Wir stellen Ihnen ein exklusives Netzwerk an Top Experten und Interim Manager temporär für Ihre Projekte und personellen Engpässe zur Verfügung
                  </p>
                  <md-button @click="toggleServicesOne()"
                             class="md-accent">
                    <md-icon>{{ ServicesOne ? 'remove' : 'add' }}</md-icon>
                    <span>mehr</span>
                  </md-button>
                  <div v-show-slide:exampleEasing="ServicesOne">
                    <p>Für die kurzfristige Überbrückung von Management-Engpässen oder einem Kapazitäten-Mangel bei Projektarbeiten oder den Fachabteilungen versorgen wir Sie mit geeignetem Fach- und Führungspersonal. Wir verfügen über ein weit verzweigtes Netzwerk an Top-Performern und hochkarätigen Managern aus Bereichen wie IT, Finanzen, Industrie, Medien, Handel uvm. </p>
                    <p>Die Expertise der praxiserprobten Manager umfasst die langjährige Berufserfahrung als Führungskraft sowie zielführende Projektabschlüsse auf nationaler und internationaler Ebene. Hier legen wir großen Wert auf die Expertise im Doing, um Ihnen und Ihrer Organisation schnellstmöglich den Rücken frei zu halten. </p>
                    <p>Profitieren Sie von unseren souveränen und präzisen Lösungen bei herausfordernden Unternehmenssituationen – auch kurzfristig. Unser Credo lautet: Go beyond! Denn wir setzen da an, wo andere aufhören.</p>
                  </div>
                </div>
              </div>
              <div class="md-layout-item md-xsmall-size-100">
                <div class="tabs-margin">
                  <img style="height:96px;"
                       src="../assets/media/hr-icon-3.svg">
                  <h1>
                    executives
                  </h1>
                  <p> Für die Besetzung Ihrer offenen Positionen im Bereich der Fach- und Führungskräfte helfen wir Ihnen genau die Kandidaten zu finden, die Sie am Markt nie finden würden.</p>
                  <md-button @click="toggleServicesTwo()"
                             class="md-accent">
                    <md-icon>{{ ServicesTwo ? 'remove' : 'add' }}</md-icon>
                    <span>mehr</span>
                  </md-button>
                  <div v-show-slide:exampleEasing="ServicesTwo">
                    <p>Wir beraten und unterstützen Sie bei der professionellen Suche nach qualifiziertem Personal im Bereich der Fach- und Führungskräfte. Darüber hinaus stehen wir Ihnen als kompetenter Ansprechpartner in allen Belangen der Organisationsentwicklung, in den Segmenten Headhunting und Executive Search sowie beim HR Outsourcing zur Seite.</p>
                    <p>Wir sprechen Top Kandidaten individuell und gezielt an. Denn wir sind der Meinung, dass die Besetzung von unternehmenskritischen Schlüsselfunktionen und -positionen ein äußerst präzises Gespür für die entsprechende Branche und den Menschen erfordert. Diese Know-how bringen wir von naniungo durch jahrelange Erfahrung mit und haben das Gespür, welche Person vor allem menschlich zum richtigen Unternehmen passt.</p>
                  </div>
                </div>
              </div>
              <div class="md-layout-item md-xsmall-size-100">
                <div class="tabs-margin">
                  <img style="height:96px;"
                       src="../assets/media/hr-icon-1.svg">
                  <h1>
                    representatives
                  </h1>
                  <p>
                    Neue Wege in der Werbung und Vermarktung, umfasst dieser Geschäftsbereich der influencer relations. Wir arbeiten mit einem eng gestrickten Netzwerk aus Meinungsführern im social media Bereich zusammen und unterstützen Sie, Ihr Unternehmen und Ihre Marke bekannt zu machen
                  </p>
                  <md-button @click="toggleServicesThree()"
                             class="md-accent">
                    <md-icon>{{ ServicesThree ? 'remove' : 'add' }}</md-icon>
                    <span>mehr</span>
                  </md-button>
                  <div v-show-slide:exampleEasing="ServicesThree">
                    <p>Gehen Sie neue Wege in der Werbung!</p>
                    <p>Sie möchten Ihre Marke oder Ihr Produkt gezielter vermarkten? Wir arbeiten mit charismatischen Meinungsmachern wie YouTubern, Bloggern und Journalisten zusammen, die Ihre Produkte in Social Media Kanälen und Printmedien repräsentieren und bekannt machen. </p>
                    <p>Sehen Sie messbar die Erfolge der zielgruppengerechten Werbung. Wir helfen Ihnen, die Reichweite Ihrer Werbung gezielt zu erhöhen und den richtigen Content zu liefern. Gehen Sie den nächsten Schritt und öffnen Sie Ihre Marketingstrategie für Influencer Marketing.</p>
                  </div>
                </div>
              </div>
            </div>
          </md-tab>
          <md-tab id="tab-unternehmen"
                  md-label="Für Bewerber">
            <div class="md-layout section-grey"
                 id="services">
              <div class="md-layout-item md-xsmall-size-100">
                <div class="tabs-margin">
                  <img style="height:96px;"
                       src="../assets/media/vitamin.svg">
                  <h1>
                    Vitamin naniungo
                  </h1>
                  <p>
                    Wir ermöglichen Ihnen den Zugang zu unserem exklusiven Pool an kurzfristig zu besetzenden Stellen und Projekten.
                  </p>
                  <md-button @click="toggleServicesOne()"
                             class="md-accent">
                    <md-icon>{{ ServicesOne ? 'remove' : 'add' }}</md-icon>
                    <span>mehr</span>
                  </md-button>
                  <div v-show-slide:exampleEasing="ServicesOne">
                    <p>naniungo ist spezialisiert auf die Vermittlung von Experten. Sei es auf freiberuflicher Basis oder in der Festanstellung.</p>
                    <p>Wir geben Ihnen den Zugang zu spannenden Unternehmen und deren Positionen, aber auch zu einem weit verzweigten Netzwerk mit interessanten Projekten im Bereich Restrukturierung, Automatisierung, Changeprozessen, Prozessoptimierung sowie Harmonisierung von Systemen und vielem mehr.</p>
                    <p>Nehmen Sie Kontakt mit uns auf und nach einem persönlichen und fachlichen Check bringen wir Sie voran! Nutzen Sie das Vitamin naniungo!</p>
                  </div>
                </div>
              </div>
              <div class="md-layout-item md-xsmall-size-100">
                <div class="tabs-margin">
                  <img style="height:96px;"
                       src="../assets/media/individual.svg">
                  <h1>
                    Karriere. Individuell.
                  </h1>
                  <p>
                    Planen Sie mit uns den nächsten Karriereschritt. Wir begleiten und unterstützen Sie gerne dabei, Ihr persönliches Wunschunternehmen zu finden und Ihre Karriere zu starten
                  </p>
                  <md-button @click="toggleServicesTwo()"
                             class="md-accent">
                    <md-icon>{{ ServicesTwo ? 'remove' : 'add' }}</md-icon>
                    <span>mehr</span>
                  </md-button>
                  <div v-show-slide:exampleEasing="ServicesTwo">
                    <p>Der nächste Karriereschritt sollte gut überlegt sein. Nutzen Sie die kompetente Beratung von naniungo für die Gestaltung ihrer Zukunft!</p>
                    <p>Durch die intensive Zusammenarbeit mit unseren Kunden können wir Ihnen helfen, genau das Unternehmen zu finden, dass Ihre Werte und Vorstellungen trifft, oder sogar übertrifft. Wir legen hohen Wert auf den persönlichen Fit, denn die Arbeit soll herausfordernd sein, aber auch Spaß machen.</p>
                    <p>Nutzen Sie unser Bewerberportal und vereinbaren Sie ein Kennenlerngespräch. Wir freuen uns auf Ihre Unterlagen und darauf, SIE kennenzulernen.</p>
                  </div>
                </div>
              </div>
              <div class="md-layout-item md-xsmall-size-100 ">
                <div class="tabs-margin">
                  <img style="height:96px;"
                       src="../assets/media/service.svg">
                  <h1>
                    First Class Service
                  </h1>
                  <p>
                    Bei uns steht der Mensch im Mittelpunkt! Werden Sie Teil der naniungo Community und profitieren Sie von einem exklusiven Netzwerk und geballerter Expertise im Kandidatenmarkt
                  </p>
                  <md-button @click="toggleServicesThree()"
                             class="md-accent">
                    <md-icon>{{ ServicesThree ? 'remove' : 'add' }}</md-icon>
                    <span>mehr</span>
                  </md-button>
                  <div v-show-slide:exampleEasing="ServicesThree">
                    <p>Hohe Transparenz, schnelle Prozesse und die Gewissheit, ernst genommen zu werden. Wir von naniungo haben hohe Wertevorstellungen und tun alles dafür, um Ihnen den besten Service zu bieten. </p>
                    <p>Nutzen Sie unser Netzwerk und unsere Erfahrung, um sich bestmöglich am Markt zu positionieren und realistische Einschätzungen und Angebote zu Ihren Karriere- und Projektmöglichkeiten zu erhalten. Wir besprechen ganz individuell Ihre nächsten Schritte. Denn denken Sie daran: Wer immer nur tut, was man schon kann, bleibt immer dort, wo man ist.</p>
                  </div>
                </div>
              </div>
            </div>
          </md-tab>
        </md-tabs>
      </div>
    </div>
    <div class="md-layout">
      <div class="md-layout-item">
        <div class="container">
          <div class="sub-tag-content xsmall-hide small-hide">
            <h1>Unsere<br> Expertise<br></h1>
            <router-link style="width:100%;"
                         v-bind:to="'about'">
              <md-button style="margin-left:1px;"
                         class="md-raised"
                         md-menu-trigger>
                <span style="text-transform:uppercase; font-size:10px; color:$accent">
                  mehr</span>
                <md-icon class="green">arrow_forward</md-icon>
              </md-button>
            </router-link>
          </div>
          <div class="sub-tag-content slogan xsmall-hide small-hide">
            <h1>Themenschwerpunkte</h1>
            <p>naniungo unterstützt Sie bei Prozess- und Optimierungsthemen entlang der Wertschöpfungskette. Wir beraten und packen dort an, wo Sie Engpässe haben oder das richtige Know-how fehlt. Unsere Experten arbeiten branchenübergreifend und erarbeiten selbstständig oder im Team die richtigen Lösungen. Ob kaufmännische Projekte, Sonderthemen oder der Marketingbereich. naniungo stellt Ihnen für jedes Thema den richtigen Experten.</p>
          </div>
          <img src="../assets/naniungo-slide-4.jpg">
        </div>
      </div>
    </div>

    <div class="md-layout section-grey">
      <div class="md-layout-item"
           style="text-align:center;">
        <h1>Themenschwerpunkte</h1>
      </div>
    </div>
    <div class="md-layout section-grey">
      <div style="margin:20px;">
      </div>
      <div v-for="columns in columnsThemen"
           :key="columns.name"
           class="md-layout-item m-25 md-xsmall-size-100">
        <div class="tabs-margin">
          <h1>
            {{columns.name}}
          </h1>
          <p>
            {{columns.subtitle}}
          </p>
          <md-button @click="columns.toggle()"
                     class="md-accent">
            <md-icon>{{ columns.show ? 'remove' : 'add' }}</md-icon>
            <span>mehr</span>
          </md-button>
          <div v-show-slide:exampleEasing="columns.show">
            <p v-for="items in columns.ps"
               :key="items">{{ items.p }} </p>
          </div>
        </div>
      </div>
    </div>
    <div class="md-layout mt-40">
      <div class="md-layout-item">
        <div class="container">
          <div class="sub-tag-content xsmall-hide small-hide">
            <h1>Karriere <br> durch <br> naniungo</h1>
            <router-link style="width:100%;"
                         v-bind:to="'karriere'">
              <md-button style="margin-left:1px;"
                         class="md-raised"
                         md-menu-trigger>
                <span style="text-transform:uppercase; font-size:10px; color:$accent">
                  mehr</span>
                <md-icon class="green">arrow_forward</md-icon>
              </md-button>
            </router-link>
          </div>
          <div class="sub-tag-content slogan xsmall-hide small-hide">
            <h1>Experten gesucht</h1>
            <p>naniungo vermittelt Fach- und Führungskräfte national sowie international. <br> Wir arbeiten mit den weltweit einflussreichsten Unternehmen zusammen, die ständig auf der Suche nach den besten der Besten sind. Gestalten Sie Ihre Zukunft durch unsere Unterstützung und gewinnen Sie den Wettstreit in der schnelllebigen Umgebung von heute für Ihren nächsten Karriereschritt.</p>
          </div>
          <img src="../assets/naniungo-slide-2.jpg">
        </div>
      </div>
    </div>

    <div class="md-layout section-grey">
      <div class="md-layout-item">
        <div class="sub"
             style="margin-left:30px;margin-top:30px;">
          <h1>Folgen Sie uns auf Instagram</h1><br>
          <a href="https://www.instagram.com/naniungo_deutschland_gmbh"
             target="_blank">
            @naniungo_deutschland_gmbh
          </a>
        </div>
      </div>
      <vue-instagram style="margin-left:10px;margin-bottom:30px;"
                     token="11854677103.81341c1.33dee6d55ea74c79848cbba748e691d9"
                     :count="20"
                     mediaType="image">
        <template slot="feeds"
                  slot-scope="props">
          <!-- <img style="margin:10px;" clas :src="props.feed.images.thumbnail.url"> -->
          <img clas
               :src="props.feed.images.thumbnail.url">
        </template>
        <template slot="error"
                  slot-scope="props">
          <div class="fancy-alert"> {{ props.error.error_message }} </div>
        </template>
      </vue-instagram>
    </div>
    <maps />
    <div class="message dark secondary">
      <md-menu md-direction="bottom-end">
        <md-button md-menu-trigger>
          <h1>Zu den Experten<md-icon class="green ml-20">arrow_forward</md-icon>
          </h1>
        </md-button>
        <md-menu-content>
          <md-menu-item>
            <router-link style="width:100%; color:white;"
                         v-bind:to="'/projects'"
                         exact>
              projects
            </router-link>
          </md-menu-item>
          <md-menu-item>
            <router-link style="width:100%; color:white;"
                         v-bind:to="'/executives'"
                         exact>
              executives
            </router-link>
          </md-menu-item>
          <md-menu-item>
            <router-link style="width:100%; color:white;"
                         v-bind:to="'/representatives'"
                         exact>
              representatives
            </router-link>
          </md-menu-item>
        </md-menu-content>
      </md-menu>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import VueInstagram from "vue-instagram";
import Maps from "../templates/Map";
// import SmoothScrollbar from 'smooth-scrollbar'

// let scrollbar

export default {
  name: "NaniungoLanding",
  components: {
    VueInstagram,
    Maps
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      jobTitle: "",
      emailAddressPrivate: "",
      phoneNumberBusiness: "",
      hobbies: "",
      ambition: "",
      functionOne: "",
      ServicesOne: false,
      ServicesTwo: false,
      ServicesThree: false,
      ssOptions: {
        damping: 0.35,
        thumbMinSize: 20,
        renderByPixels: true,
        alwaysShowTracks: false,
        continuousScrolling: true,
        delegateTo: null,
        plugins: {}
      },
      columnsThemen: [
        {
          name: "Accounting",
          subtitle:
            "naniungo unterstützt Sie mit Experten bei Ihren Projekten und Herausforderungen im Accounting, um schnell und flexibel auf Marktveränderungen zu reagieren. Wir verbinden Sie mit genau dem richtigen Experten für unterschiedliche Fragestellungen.",
          show: false,
          icon: "accounting.svg",
          toggle() {
            this.show = !this.show;
          },
          ps: [
            {
              p:
                "Unser Netzwerk erstreckt sich von Experten im Bereich klassischer Buchhaltungsthemen wie der Unterstützung im Jahresabschluss nach verschiedenen Rechnungslegungsstandards, dem Führen der Haupt- und Nebenbücher und der Unterstützung im Tagesgeschäft, sowie Spezialthemen, bei denen es unter anderem um elektronische Rechnungsworkflows, Aufbau von financial Shared Service Centern oder Prozessthemen im P2P oder R2R Umfeld geht. Zudem unterstützen unsere Experten auch bei Schnittstellen Themen in ERP Systemen, wenn es um Werteflüsse oder beispielsweise die Einführung von S4/Hana geht."
            }
          ]
        },
        {
          name: "Controlling",
          subtitle:
            "Leicht verständliche Analysen, aussagefähige Kennzahlen und klare Handlungsempfehlungen nehmen wir und unsere Experten gerne für Sie in die Hand, damit Sie sich Ihrem Kerngeschäft widmen können.",
          show: false,
          icon: "controlling.svg",
          toggle() {
            this.show = !this.show;
          },
          ps: [
            {
              p:
                "Wir begleiten unsere Kunden bei der Optimierung von Controllingprozessen, bei der Implementierung von operativen und strategischen Controlling-Instrumenten (Kosten- und Leistungsrechnung, Budgetierung, Produktkalkulation, Marktsegmentrechnung, Vertriebscontrolling, Produktionscontrolling, Beteiligungscontrolling, Personalcontrolling, Profit Center-Rechnung, Portfolioanalyse, SWOT-Analyse, Reportingstrukturen und Werteflüssen etc.). Der digitale Wandel im Bereich RPA (robotic process automation) im Controlling ist ebenfalls ein häufiger Ansatzpunkt, bei dem wir unsere Kunden unterstützen."
            },
            {
              p:
                "Werfen Sie einen Blick auf unsere Experten im Bereich „projects“ und „executives“ oder kontaktieren Sie uns gerne für mehr Informationen."
            }
          ]
        },
        {
          name: "Marketing",
          subtitle:
            "Die Zeiten des Gebrauchs traditioneller Kanäle im Bereich der Medien gehört mittlerweile der Vergangenheit an und die Unternehmen, die sich optimal auf diesen Wechsel anpassen und mit modernen Marketingaktivitäten ihre Adressaten zielgerichtet erreichen, werden bekannter und erfolgreicher! Wir helfen Ihnen dabei.",
          show: false,
          icon: "marketing.svg",
          toggle() {
            this.show = !this.show;
          },
          ps: [
            {
              p:
                "Beim modernen Marketing liegt der Fokus auf den Bedürfnissen und Werten der Unternehmen, vereint mit der Digitalisierung. Wir bieten Ihnen die Möglichkeit, sich mit ganz neuen und modernen Möglichkeiten aufzustellen. Wir verbinden Sie mit einflussreichen Influencern, Bloggern oder Journalisten um die Themen, auf die es Ihnen ankommt, gezielt zu vermarkten. Neben Influencer Marketing zählt ebenfalls die Entwicklung und Umsetzung einer eigenen Marketingstrategie, die Auswahl der Marketinginstrumente sowie die Markenentwicklung und Corporate Identity zu einem erfolgreichen Konzept. Die neuen Werkzeuge im Bereich E-Commerce, Online-Marketing, Suchmaschinen-Marketing, Social-Media und Big Data sind viel komplexer geworden, aber wir und unsere Experten helfen Ihnen sich gezielt und erfolgreich zu positionieren."
            }
          ]
        },
        {
          name: "Finance Functions",
          subtitle:
            "In der Kategorie Finance Functions eröffnen wir Ihnen ein Netzwerk an Experten aus dem Bereich Corporate Finance, Treasury, Tax, Audit, Merger & Acquisitions und Risk Management. ",
          show: false,
          icon: "steuern.svg",
          toggle() {
            this.show = !this.show;
          },
          ps: [
            {
              p:
                "Bewertungs- und Grundsatzthemen, steuerliche Bewertung und internationales Steuerrecht, Konsolidierungsaufgaben oder Transferpreisberechnung- und Dokumentation sind Themengebiete, welche wir mit unseren Experten abdecken. Hinzu kommen Tätigkeiten bei der Auswahl und Implementierung von internen Kontrollsystemen, Valuation & Modelling, der Planung und Durchführung von Audits & Compliance, sowie SOX Implementierungen."
            },
            {
              p:
                "Werfen Sie einen Blick auf unsere Experten im Bereich „projects“ und „executives“ oder kontaktieren Sie uns für mehr Informationen."
            }
          ]
        },
        {
          name: "Sonderprojekte",
          subtitle:
            "Sie stehen vor großen Veränderungen in Ihrer Organisation? Der Bereich der Sonderprojekte umfasst alle Spezialthemen, bei denen Sie ein ganz bestimmtes Know-how außerhalb der klassischen Finanzbereiche benötigen.",
          show: false,
          icon: "steuern.svg",
          toggle() {
            this.show = !this.show;
          },
          ps: [
            {
              p:
                "Im Bereich der Sonderprojekte greifen wir auf einen ausgewählten Experten Pool mit jahrelanger Branchenerfahrung zu, der Sie in außergewöhnlichen Unternehmenssituationen schnell und effizient unterstützt. Kerngebiete sind hier Projekte im Bereich Business Transformation, Procurement, Facility Management, Supply Chain Management, HR und IT. Unsere Interim Manager sind Profis auf Ihrem Gebiet und können ohne lange Einarbeitung Lösungen erarbeiten und Effizienz schaffen. Zudem sind sie erfahrene Führungskräfte und auch im Projektmanagement oder als Projektleiter bei ERP-Implementierungen, sowie im Prozessmanagement ein echter Mehrwert."
            },
            {
              p: "Sprechen Sie uns jederzeit an!"
            }
          ]
        }
      ]
    };
  },
  computed: mapState({
    candidates: state => state.candidates.candidates
  }),
  methods: {
    ...mapActions("candidates", ["addCandidate", "deleteCandidate"]),
    toggleServicesOne() {
      this.ServicesOne = !this.ServicesOne;
    },
    toggleServicesTwo() {
      this.ServicesTwo = !this.ServicesTwo;
    },
    toggleServicesThree() {
      this.ServicesThree = !this.ServicesThree;
    },
    getSvg(name) {
      return require("../assets/media/" + name);
    }
  },
  created() {
    // this.$store.dispatch('candidates/getCandidates')
  },
  mounted() {
    // scrollbar = SmoothScrollbar.init(
    //     this.$refs.scrollArea, this.ssOptions)
    // this.scrollbar = scrollbar
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/css/shared.scss";

.landing {
  max-width: 100vw;
  -webkit-overflow-scrolling: touch !important;
  overflow-x: hidden !important;
  max-width: 100vw;
}

.bg {
  background: url("../assets/naniungo-slide-9.jpg") no-repeat center center
    fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: right 0px top 44px !important; 
  height: 100vh;
  // -webkit-transform: translate3d(0, 0, 0);
}
.bg-1 {
  background: url("../assets/naniungo-slide-4.jpg") no-repeat center center
    fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 500px;
}

.wrapper {
  min-height: 400px;
  align-items: center;
  background-image: linear-gradient(
    to right,
    $pp-blue,
    $pp-ltblue,
    $sp-yellow,
    $pp-purple,
    $pp-blue
  );
  background-size: 600%;
  background-position: 0 0;
  box-shadow: inset 0 0 5em rgba(0, 0, 0, 0);
  display: flex;
  font-family: "Lato", Arial, sans-serif;
  height: 100%;
  justify-content: center;
  /* Animation */
  animation-duration: 20s;
  animation-iteration-count: infinite;
  animation-name: gradients;
  // p{
  //   color:white;
  // }
  // h1{
  //   color:white !important;
  // }
}

.landing-tabs {
  min-height: 400px;
  .md-tab {
    padding: 0px !important;
  }
}

@media (max-width: 830px) {
  h1 {
    font-size: 2em;
  }
}
@keyframes gradients {
  0% {
    background-position: 0 0;
  }
  25% {
    background-position: 50% 0;
  }
  50% {
    background-position: 90% 0;
  }
  60% {
    background-position: 60%;
  }
  75% {
    background-position: 40%;
  }
  100% {
    background-position: 0 0;
  }
}

.md-plain {
  font-family: "avenir_medium" !important;
  background-color: white;
}

@font-face {
  font-family: "avenir_medium";
  src: font-url("../fonts/Avenir_LT_65_Medium.woff") format("woff"),
    font-url("../fonts/Avenir_LT_65_Medium.woff2") format("woff2");
}

// .smooth-scrollbar {
//   width: 100%;
//   height: 100%;
// }
</style>
